import type { OrderStageView } from '@/api/types'
import { StageStatusChip } from './StatusChip'
import { cn } from './cn'

const DONE = new Set<OrderStageView['status']>(['COMPLETED', 'TRANSFERRED', 'SKIPPED'])
const ACTIVE = new Set<OrderStageView['status']>(['AVAILABLE', 'ACCEPTED', 'IN_PROGRESS', 'PAUSED'])

/** Vertical progress of an order's production stages. */
export function StageStepper({
  stages,
  onSelect,
}: {
  stages: OrderStageView[]
  onSelect?: (stage: OrderStageView) => void
}) {
  return (
    <ol className="relative ml-2">
      {stages.map((stage, i) => {
        const done = DONE.has(stage.status)
        const active = ACTIVE.has(stage.status)
        const dotColor = done ? 'bg-green-500' : active ? 'bg-indigo-500' : 'bg-black/20'
        const interactive = !!onSelect
        return (
          <li key={stage.id} className="relative flex gap-3 pb-4 last:pb-0">
            <div className="flex flex-col items-center">
              <span className={cn('mt-1.5 h-3 w-3 shrink-0 rounded-full', dotColor)} aria-hidden />
              {i < stages.length - 1 && <span className="w-px flex-1 bg-black/10" aria-hidden />}
            </div>
            <div
              className={cn(
                'min-w-0 flex-1 rounded-lg px-1 py-0.5',
                interactive && 'cursor-pointer active:bg-black/5',
              )}
              onClick={interactive ? () => onSelect(stage) : undefined}
              role={interactive ? 'button' : undefined}
              tabIndex={interactive ? 0 : undefined}
              onKeyDown={
                interactive
                  ? (e) => {
                      if (e.key === 'Enter') onSelect(stage)
                    }
                  : undefined
              }
            >
              <div className="flex items-center justify-between gap-2">
                <span className="truncate text-sm font-medium text-tg-text">
                  {stage.sequence_no}. {stage.name}
                </span>
                <StageStatusChip status={stage.status} />
              </div>
              <div className="mt-0.5 text-xs text-tg-hint">
                Норматив: {stage.norm_duration_minutes} мин
                {stage.requires_photo && ' · фото обязательно'}
                {stage.is_optional && ' · опционально'}
              </div>
            </div>
          </li>
        )
      })}
    </ol>
  )
}
